import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/SubTopic3/GLB_LimpiezaKobalto.glb";
import { GUI } from "dat.gui";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";

export class LimpiezaKobalto extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		this.objectsMaterials = {
			beforePesatañas: null,
			newPesatañas: null,
		};
		this.observerListtneners();
		// this.helpers();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			// gltf.scene.visible = false;
			this.add(gltf.scene);

			this.Cafetera_Kobalto = gltf.scene.getObjectByName("Cafetera_Kobalto", true);
			this.Parillas = gltf.scene.getObjectByName("Parillas", true);
			this.BaseParillas = gltf.scene.getObjectByName("BaseParillas", true);
			this.Puerta = gltf.scene.getObjectByName("Puerta", true);
			this.Pestaña_02 = gltf.scene.getObjectByName("Pestaña_02", true);
			this.Pestaña_01 = gltf.scene.getObjectByName("Pestaña_01", true);
			this.Cubeta = gltf.scene.getObjectByName("Cubeta", true);
			this.ResiduosCafe = gltf.scene.getObjectByName("ResiduosCafe", true);
			this.Rollo = gltf.scene.getObjectByName("Rollo", true);
			this.Spray = gltf.scene.getObjectByName("Spray", true);
			this.Trapo = gltf.scene.getObjectByName("Trapo", true);
		});
	}

	onVisibleObjectSub3Act3() {
		this.Cafetera_Kobalto.visible = true;
		this.Parillas.visible = true;
		this.BaseParillas.visible = true;
		this.Puerta.visible = true;
		this.Pestaña_02.visible = true;
		this.Pestaña_01.visible = true;
		this.Cubeta.visible = false;
		this.Rollo.visible = false;
		this.Spray.visible = false;
		this.Trapo.visible = false;

		this.objectsMaterials.beforePesatañas = this.Pestaña_02;
		let objectPestana = this.Pestaña_02;
		const newMaterialPestana = objectPestana.material.clone();
		newMaterialPestana.opacity = 1;
		newMaterialPestana.transparent = true;
		this.objectsMaterials.newPesatañas = newMaterialPestana;

		// this.helpersChild();
	}

	observerListtneners() {
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.trapo, (step) => {
			this.Trapo.visible = true;
			this.Trapo.position.set(-0.3215, 0.6184, 0.4704);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.papel, (step) => {
			this.Trapo.visible = false;
			this.Trapo.position.set(-0.3215, 0.6184, 0.4704);
			this.Rollo.visible = true;
			this.Rollo.position.set(-0.3215, 0.6184, 0.4704);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.showConetenedorInit, (step) => {
			this.onAnimationShowContenedor(step);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.removeCoffeContainer, () => {
			this.ResiduosCafe.visible = false;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.saveContenedorInit, (step) => {
			this.onAnimationSaveContenedor(step);
		});
	}

	eliminateAnimation() {
		if (this.animation) {
			this.animation.kill();
		}
	}

	onAnimationShowContenedor(step) {
		this.eliminateAnimation();
		this.Cubeta.visible = true;
		this.Pestaña_01.material = this.objectsMaterials.newPesatañas;
		this.Pestaña_02.material = this.objectsMaterials.newPesatañas;
		this.Puerta.material = this.objectsMaterials.newPesatañas;
		gsap.to([this.Pestaña_01.material, this.Pestaña_01.material, this.Puerta.material], {
			opacity: 0,
			duration: 1,
			onComplete: () => {
				gsap.to(this.Cubeta.position, {
					x: 0.3003,
					y: 0.1133,
					z: 0.1919,
					duration: 1,
				});
				gsap.to(this.Cubeta.rotation, {
					x: 1.4409,
					y: 1.4409,
					z: -0.6543,
					duration: 1,
					onComplete: () => {
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.showConetenedorFinish, step);
					},
				});
			},
		});
	}

	onAnimationSaveContenedor(step) {
		this.eliminateAnimation();

		gsap.to(this.Cubeta.position, {
			x: 0,
			y: 0,
			z: 0,
			duration: 1,
		});
		gsap.to(this.Cubeta.rotation, {
			x: 0,
			y: 0,
			z: 0,
			duration: 1,
			onComplete: () => {
				gsap.to([this.Pestaña_01.material, this.Pestaña_01.material, this.Puerta.material], {
					opacity: 1,
					duration: 1,
					onComplete: () => {
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.steps.saveContenedorFinish, step);
					},
				});
			},
		});
	}

	onPosition(x = 0, y = 0, z = 0) {
		this.position.set(x, y, z);
	}

	onAnimate(object, previousObject) {
		this.eliminateAnimation();

		//*regresar el color al anterior
		this.beforeColor = object.material.emissive;
		if (previousObject !== undefined) {
			if (this[previousObject] !== undefined) {
				this[previousObject].material.emissive = this.beforeColor;
			}
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		object.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Limpieza");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this, "visible").name("Visible");
	}

	helpersChild() {
		// this.helperMethod("Pestaña_02", this.Pestaña_02);
		this.helperMethod("Cubeta", this.Cubeta);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -20, 20).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -20, 20).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -20, 20).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
